import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router';

import { manager, teamAdmin, teamMember } from '../../constants/appConstants';
import PageLoader from '../loaders/pageLoader';
import { rootLoader } from '../loaders/rootLoader';
import ProtectedRoute from '../protectedRoute';
import { queryClient } from '../Root';

const CreateCardUserPage = lazy(() => import('../../components/pages/wallet/createCardUser'));

export const cardUserRoutes = {
	path: '/card-users',
	element: <Outlet />,
	children: [
		{
			index: true,
			element: <Navigate to="/card-users/new" replace />,
		},
		{
			path: 'new',
			element: (
				<ProtectedRoute allowedRoles={[teamAdmin, manager, teamMember]}>
					<Suspense fallback={<PageLoader />}>
						<CreateCardUserPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: (ctx: any) => rootLoader({ queryClient, ...ctx }),
		},
	],
};
